import { PageContainer } from '@components';
import { Contribution } from '@views/Contribution';
import { useParams } from 'react-router';
import { useEffect } from 'react';
import { store } from '@store';

const ContributionPage = () => {
  const { id } = useParams();

  const hitsFiltered = store.use.hitsFiltered();
  const getHitsAchievementAction = store.use.getHitsAchievementAction().call;
  const isLoadingGetHitsAchievementAction =
    store.use.getHitsAchievementAction().status === 'LOADING';

  useEffect(() => {
    getHitsAchievementAction({ idProject: id, body: { model: {} } });
  }, [id]);

  return (
    <PageContainer>
      <Contribution hitsAchievement={hitsFiltered} isLoading={isLoadingGetHitsAchievementAction} />
    </PageContainer>
  );
};
export default ContributionPage;
